import { jsx as e, jsxs as t } from "react/jsx-runtime";
//#region lib/components/CropDialog/MenuOption.tsx
var n = ({ onPress: n, children: r }) => /* @__PURE__ */ t("a", {
	contentEditable: !1,
	tabIndex: 0,
	className: "\n        block\n        relative\n        h-10\n        w-10\n        rounded-full\n        overflow-hidden\n        group/icon\n        focus:ring-2\n        ",
	onKeyDownCapture: (e) => {
		e.key === " " && (e.preventDefault(), n());
	},
	onMouseDown: (e) => {
		e.preventDefault(), n();
	},
	onMouseUpCapture: (e) => {
		e.preventDefault(), e.stopPropagation();
	},
	children: [/* @__PURE__ */ e("span", { className: "absolute w-full h-full bg-black opacity-60 group-hover/icon:opacity-80 flex items-center justify-center" }), /* @__PURE__ */ e("span", {
		className: "absolute w-full h-full flex items-center justify-center",
		children: r
	})]
});
//#endregion
export { n as MenuOption };
